{
  "common": {
    "entityTypes": {
      "User": "User",
      "Department": "Department",
      "Role": "Position",
      "Process": "Process",
      "ProcessStepRecording": "Process Step Recording",
      "ProcessStepAssignment": "Process Step Assignment",
      "Survey": "Survey",
      "Artifact": "Document",
      "ExternalContact": "External Contact",
      "SoftwareSystem": "Software System",
      "OrgFunction": "Function",
      "Organization": "Organization",
      "BliksyGeneration": "Bliksy Generation",
      "ProcessConnection": "Process Connection",
      "ProcessChain": "Process Chain",
      "ProcessMapPosition": "Process Map Position",
      "ProcessMapLaneDimension": "Process Map Lane Dimension",
      "Tenant": "Tenant",
      "AppRegistry": "App Registry",
      "PlatformSettings": "Platform Settings"
    },
    "itemsSelected": "{{count}} selected",
    "selectAll": "Select all",
    "showMore": "Show more",
    "showLess": "Show less",
    "deleted": "deleted",
    "viewAll": "View All",
    "noItemsFound": "No items found",
    "Yes": "Yes",
    "No": "No",
    "Back": "Back",
    "back": "Back",
    "Done": "Done",
    "Beta": "Beta",
    "Save": "Save",
    "Remove": "Remove",
    "Edit": "Edit",
    "Search": "Search",
    "Create": "Create",
    "Continue": "Continue",
    "continue": "Continue",
    "Submitting": "Submitting...",
    "submit": "Submit",
    "Settings": "Settings",
    "Logout": "Log out",
    "loading": "Loading...",
    "chatError": "Something went wrong. Please try again.",
    "retry": "Retry",
    "download": "Download",
    "trialDaysLeft": "Trial expires in {{days}} days",
    "trialLastDay": "Trial expires today",
    "trialExpired": "Trial has expired",
    "ErrorBoundary": {
      "title": "Something went wrong",
      "description": "We encountered an error while loading this page. You can try again or navigate to another page using the sidebar.",
      "tryAgain": "Try Again",
      "goToSettings": "Go to Settings",
      "goHome": "Go Home",
      "viewErrorDetails": "View error details"
    },
    "NotFound": {
      "title": "Feature Coming Soon",
      "description": "We're actively working on this feature. It will be available soon!",
      "suggestion": "In the meantime, explore other features or check our roadmap to see what's coming next.",
      "goToDashboard": "Go to Dashboard",
      "goToLogin": "Go to Login",
      "viewRoadmap": "View Roadmap"
    },
    "Apps": {
      "notFound": "App not found or not available for this organization.",
      "manageTitle": "App Catalog",
      "manageDescription": "Enable your organization's apps and assign seats",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "activation": "Activation",
      "enableSuccess": "App enabled successfully.",
      "enableFailed": "Failed to enable app.",
      "disableSuccess": "App disabled successfully.",
      "disableFailed": "Failed to disable app.",
      "seatsTitle": "App Seats",
      "seatsMembers": "Members with access",
      "seatsSaved": "Seats saved.",
      "seatDataIntro": "A seat grants full read access in this app to: {{categories}}.",
      "seatDataCategories": {
        "processes": "Processes",
        "processSteps": "Step details incl. notes, capacity and cost data",
        "surveys": "Survey answers incl. individual step ratings and comments, case frequency and processing time — for every process, regardless of department",
        "systems": "Systems",
        "roles": "Functions",
        "teams": "Teams",
        "departments": "Departments",
        "orgMembers": "Member directory (incl. email and status)",
        "artifacts": "Documents",
        "externalContacts": "External contacts (incl. email)",
        "processChains": "Process chains (incl. the linked processes)"
      },
      "notAllowed": "Not allowed",
      "notAllowedNotice": "This app is not allowed for your organization.",
      "seatsCount": "{{used}} / {{limit}} seats",
      "seatsNeedEnabledApp": "Seats can only be assigned once the app is enabled.",
      "seatsOverLimit": "{{over}} over the limit",
      "seatsNoCapacity": "No seats available",
      "category": {
        "analysis": "Analysis",
        "dataCapture": "Data capture",
        "sales": "Sales"
      }
    },
    "Sidebar": {
      "Dashboard": "Dashboard",
      "ActiveMonitoring": "Active Monitoring",
      "ComingSoon": "Coming Soon",
      "ensureContinuity": "Active Monitoring ensures your business continuity.",
      "AreTheRelevant": "Are all the relevant process members available at the moment?",
      "areThereBottleneck": "Are there bottlenecks in your process landscape?",
      "LearnMore": "LearnMore",
      "Processes": "Processes",
      "AllProcesses": "All Processes",
      "MyTasks": "My Tasks",
      "ProcessLandscape": "Process Landscape",
      "ProcessChains": "Process Chains",
      "ProcessEditor": "Process Editor",
      "Organization": "Organization",
      "MyDepartment": "My Department",
      "MyOrgFunctions": "My Functions",
      "MySystems": "My Systems",
      "Systems": "Systems",
      "OrgCatalogs": "Organization Catalogs",
      "AllDepartments": "All Departments",
      "AllFunctions": "All Functions",
      "AllTeams": "All Teams",
      "AllMembers": "All People",
      "AllSoftwareSystems": "All Software Systems",
      "SystemLandscape": "System Landscape",
      "AllExternalContacts": "All External Contacts",
      "AllArtifacts": "All Documents",
      "OrgChart": "Organization Chart",
      "Analytics": "Analytics",
      "AiUsage": "AI Usage",
      "SeeWhichPeople": "See which people or systems are critical in your processes, where is the biggest room for improvement?",
      "Survey": "Survey",
      "Apps": "Apps",
      "ManageApps": "Manage Apps",
      "DataSync": "Data sync",
      "needSpecificDetail": "Do you need specific details about certain processes? Who is the expert on this? Need to answer questions regarding sustainability?",
      "Settings": "Settings",
      "OrgSettings": "Organization Settings",
      "UserManagement": "User Management",
      "TenantManagement": "Tenant Management",
      "InitialConfig": "Initial Configuration",
      "SoftwareSystems": "Software-Systems",
      "MyOverview": "My Work Environment",
      "RecordingDashboard": "Recording Cockpit",
      "AuditLogs": "Audit Logs",
      "ShadowSystems": "Shadow Systems",
      "Help": "Help",
      "PartnerContent": "Partner content",
      "AccountManagement": "Accounts"
    },
    "Name": "Name",
    "Email": "Email",
    "Logo": "Logo",
    "Change": "Change",
    "Upload": "Upload",
    "Created": "Created",
    "Description": "Description",
    "Details": "Details",
    "Category": "Category",
    "Type": "Type",
    "Status": "Status",
    "FirstName": "First Name",
    "LastName": "Last Name",
    "Actions": "Actions",
    "edit": "Edit",
    "actions": "Actions",
    "viewDetail": "View Detail",
    "clone": "Clone",
    "Updated": "Updated",
    "UserTypes": "User Types",
    "Classification": "Classification",
    "DepartmentManager": "Department Manager",
    "Error": "Error",
    "errorOccurred": "An error occurred",
    "success": "Success",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "confirm": "Confirm",
    "processing": "Processing...",
    "sending": "Sending...",
    "delete": "Delete",
    "create": "Create",
    "confirmDelete": "Confirm Delete",
    "confirmDeleteDescription": "Are you sure you want to delete {{entity}}? This action cannot be undone.",
    "unsavedChanges": "Unsaved Changes",
    "unsavedChangesDescription": "You have unsaved changes. Are you sure you want to close?",
    "stay": "Continue editing",
    "discardChanges": "Discard Changes",
    "noOptionsAvailable": "No options available",
    "Instructions": "Instructions",
    "add": "Add",
    "search": "Search",
    "searchOrCreate": "Search or create...",
    "noResults": "No results found.",
    "uploading": "Uploading",
    "uploadingEllipsis": "Uploading...",
    "or": "Or",
    "you": "You",
    "moreCount": "(+{{count}} more)",
    "dropzone": {
      "dragAndDrop": "Drag & drop, or",
      "clickToSelect": "click to select files",
      "maxFileSize": "Max {{maxSize}} MB files are allowed",
      "rejectedType": "Not added – file type not supported: {{names}}",
      "rejectedSize": "Not added – larger than {{maxSize}} MB: {{names}}"
    },
    "notAvailable": "N/A",
    "system": "System",
    "empty": "(empty)",
    "error": "Error",
    "excelUpload": {
      "downloadTemplateTitle": "Download template",
      "downloadTemplateDesc": "Contains exactly these columns – fill in and upload.",
      "parsedRows": "{{count}} rows parsed",
      "parseFailed": "The file could not be read",
      "headerMismatch": "No column matches the template. Please use the column headers from the template.",
      "dragOrBrowse": {
        "prefix": "Drag & drop, or",
        "browse": "click to select files"
      },
      "maxFileSize": "Max 10 MB files are allowed"
    },
    "Workspaces": "Workspaces",
    "Help": "Help"
  },
  "userTypes": {
    "system_admin": "System Admin",
    "system_admin_description": "Full system access and configuration",
    "org_manager": "Organization Manager",
    "org_manager_description": "Manage organization settings and people",
    "org_member": "Organization Member",
    "org_member_description": "Standard member with basic access",
    "partner_admin": "Partner admin",
    "partner_admin_description": "Manages the partner organization's leads, team and profile",
    "partner_staff": "Partner staff",
    "partner_staff_description": "Submits and tracks their own leads in the partner area"
  },
  "userStatus": {
    "inactive": "Inactive",
    "pending": "Pending",
    "active": "Active",
    "suspended": "Suspended"
  },
  "userClassification": {
    "internal": "Internal Employee",
    "external": "External Employee",
    "internalShort": "Internal",
    "externalShort": "External"
  },
  "seatLimits": {
    "title": "Seat limits",
    "systemAdmins": "System admins",
    "orgManagers": "Organization managers",
    "members": "Basic users"
  },
  "bpmnEventTypes": {
    "none": "Manual start",
    "none_description": "Started manually by a person",
    "message": "Incoming request",
    "message_description": "Triggered by an incoming request (e.g. email, call, or message)",
    "timer": "Time / Deadline",
    "timer_description": "Triggered at a specific time or after a deadline",
    "conditional": "Conditional",
    "conditional_description": "Triggered when a condition becomes true",
    "signal": "Signal",
    "signal_description": "Triggered by a signal broadcast",
    "multiple": "Multiple",
    "multiple_description": "Multiple triggers, one is required",
    "parallelMultiple": "Parallel Multiple",
    "parallelMultiple_description": "Multiple triggers, all are required",
    "error": "Error",
    "error_description": "Triggered by an error",
    "cancel": "Cancel",
    "cancel_description": "Triggered when transaction is cancelled",
    "escalation": "Escalation",
    "escalation_description": "Triggered by an escalation",
    "compensation": "Compensation",
    "compensation_description": "Triggered for compensation handling",
    "link": "Link",
    "link_description": "Links to another part of the process",
    "terminate": "Terminate",
    "terminate_description": "Immediately ends the process"
  },
  "pageTitles": {
    "home": "Home",
    "login": "Login",
    "myTasks": "My Tasks",
    "myTasksWithCount": "My Tasks ({{count}})",
    "processDetail": "{{name}}",
    "processFlowFullscreen": "{{name}} - Flow Visualization",
    "allProcesses": "All Processes",
    "createProcesses": "Create Processes",
    "startRecording": "Start Recording - {{name}}",
    "stepRecording": "Recording - {{name}}",
    "orgMembers": "People",
    "orgMemberDetail": "{{name}}",
    "departments": "Departments",
    "departmentDetail": "{{name}}",
    "mySystems": "My Systems",
    "orgFunctionDetail": "{{name}}",
    "functions": "Functions",
    "teams": "Teams",
    "myOrgFunctions": "My Functions",
    "systems": "Systems",
    "systemDetail": "{{name}}",
    "systemLandscape": "System Landscape",
    "processMap": "Process Landscape",
    "processChains": "Process Chains",
    "processEditor": "Process Editor",
    "artifacts": "Documents",
    "artifactDetail": "{{name}}",
    "externalContacts": "External Contacts",
    "externalContactDetail": "{{name}}",
    "orgChart": "Organization Chart",
    "settings": "Settings",
    "tenants": "Tenants",
    "departmentMembers": "People in my department",
    "departmentTeams": "My Department Teams",
    "userManagement": "User Management",
    "softwareList": "Software List",
    "manageApps": "App Catalog",
    "dataSync": "Data sync",
    "createDepartments": "Create Departments",
    "dashboard": "My Work Environment",
    "shadowSystems": "Shadow Systems",
    "help": "Customer Service",
    "supportTickets": "Support Tickets"
  },
  "noDashboardAccess": {
    "title": "No workspace access yet",
    "description": "Your account does not have access to a workspace view. Please contact your administrator to have the right role assigned."
  },
  "about": {
    "title": "About BLIKS IO",
    "frontendVersion": "Frontend",
    "backendVersion": "Backend",
    "buildInfo": "Build"
  },
  "helpCenter": {
    "title": "Customer Service",
    "subtitle": "Submit a request and track your tickets",
    "contactUs": "Contact & Support",
    "contactSubtitle": "Get in touch with our support team",
    "viewTickets": "My Tickets",
    "openTicketsCount": "Open tickets: {{count}}",
    "ticketsWithNewReplyCount": "Tickets with a new reply: {{count}}",
    "contact": {
      "category": "Category",
      "categoryPlaceholder": "What can we help you with?",
      "categories": {
        "incident": "Report an issue",
        "request": "Submit a request",
        "change": "Request a change",
        "complaint": "Submit a complaint"
      },
      "summary": "Subject",
      "summaryPlaceholder": "Brief summary of your request",
      "description": "Description",
      "descriptionPlaceholder": "Please describe your request in detail...",
      "submit": "Submit request",
      "successTitle": "Request submitted!",
      "successMessage": "Your request has been submitted. Our team will get back to you shortly.",
      "errorMessage": "Something went wrong. Please try again or contact {{supportEmail}}.",
      "newRequest": "Submit another request",
      "ticketReference": "Ticket number: {{number}}",
      "attachmentsTitle": "Attach screenshots",
      "attachmentsHint": "Up to {{count}} images, max {{size}} MB each (PNG, JPEG, WebP)",
      "attachmentRemove": "Remove {{name}}"
    }
  },
  "supportTickets": {
    "newReply": "New reply",
    "title": "Support Tickets",
    "subtitle": "View your support requests",
    "loadErrorTitle": "Couldn't load your tickets",
    "loadError": "Support is temporarily unavailable. Please try again later.",
    "empty": "No tickets yet",
    "emptyDescription": "You haven't created any support tickets yet.",
    "open": "Open",
    "closed": "Closed",
    "status": {
      "received": "Received",
      "inProgress": "In progress",
      "resolved": "Resolved",
      "merged": "Merged"
    },
    "detail": {
      "title": "Support request",
      "loadErrorTitle": "This request could not be loaded",
      "loadError": "Support is temporarily unavailable. Please try again later.",
      "noMessages": "There are no messages on this request yet.",
      "notLiveChat": "Not a live chat – replies arrive here and by email, usually promptly.",
      "authorYou": "You",
      "authorSupport": "Support",
      "replyLabel": "Reply",
      "replyPlaceholder": "Write a reply to support...",
      "replySubmit": "Send reply",
      "sendShortcut": "⌘/Ctrl + Enter",
      "attach": "Attach image",
      "replyError": "Your reply could not be sent. Please try again.",
      "resolvedHint": "This request is closed. If something is still open, you can reopen it.",
      "mergedNotice": "This request was merged with another request and is being handled there.",
      "mergedLink": "Go to request #{{number}}",
      "reopenAction": "Reopen request",
      "reopenLabel": "What is still open?",
      "reopenSubmit": "Send and reopen",
      "attachmentDownload": "Download {{name}}",
      "attachmentDownloadAction": "Download",
      "attachmentOpen": "Open {{name}}",
      "attachmentError": "The attachment could not be downloaded. Please try again."
    }
  }
}
